// extracted by mini-css-extract-plugin
module.exports = {"root":"ModifySelectedRooms_root__8Y3Xr","closeButton":"ModifySelectedRooms_closeButton__31d7V"};